import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import oaiApiClient from '../clients/oai-api/oai-api-client';
import { GetNotificationsParams } from '../clients/oai-api/types/requests/GetNotificationsParams';

export const useNotifications = ({
  limit = 10,
  page = 1,
  unread,
}: GetNotificationsParams) => {
  return useInfiniteQuery({
    queryKey: ['notifications'],
    queryFn: async ({ pageParam }) => {
      const res = await oaiApiClient.getNotifications({
        limit,
        page: pageParam,
        unread,
      });

      return {
        data: res,
        nextCursor: res?.notifications?.length === limit ? pageParam + 1 : null,
      };
    },
    refetchInterval: 0,
    initialPageParam: page,
    getNextPageParam: (lastPage) => {
      return lastPage.nextCursor;
    },
  });
};

export const useNewestNotification = () => {
  return useQuery({
    queryKey: ['notifications', 'newest'],
    queryFn: async () => {
      const res = await oaiApiClient.getNotifications({
        limit: 1,
        page: 1,
        unread: true,
      });

      return res.notifications?.[0] || null;
    },
    refetchInterval: 5000,
  });
};
